import Flickity from 'flickity-imagesloaded';
import debounce from 'lodash/debounce';

export default class Logos {
  constructor() {
    this.$el = document.querySelectorAll('.js-logos-carousel');
    this.$el.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;
    this.minWidth = 1024;

    if (window.innerWidth < this.minWidth) {
      this.createCarousel();
    }

    window.addEventListener('resize', debounce(this.onResize, 250).bind(this));
  }

  onResize() {
    if (window.innerWidth < this.minWidth) {
      this.createCarousel();
    } else {
      this.destoryCarousel();
    }
  }

  createCarousel() {
    this.carousel = new Flickity(this.$el, {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      imagesLoaded: true,
      wrapAround: true,
    });
  }

  destoryCarousel() {
    if (this.carousel) {
      this.carousel.destroy();
    }
  }
}